import React from 'react'
import { Modal, Button, Icon, Input, Table } from 'antd';
import isEqual from 'lodash/isEqual';
import './style/index.less';

const Search = Input.Search;
class App extends React.Component {
  static defaultProps = {
    prefixCls: 'cs-browser'
  }
  constructor(props) {
    super(props);
    this.state = {
      datas: props.datas || [],
      searchDatas: props.datas || [],
      valueSpan: '',
      value: '',
      visible: false,
      count: 0,
      current: 1,
      search: '',
    }
  }

  componentWillReceiveProps(nextProps) {
    const { datas, value } = this.props;
    let nState = null;
    if (nextProps.datas && !isEqual(nextProps.datas, datas)) {
      nState = { datas: nextProps.datas, searchDatas: nextProps.datas };
    }
    if (nextProps.value && nextProps.value !== value) {
      nState = { value: nextProps.value };
      const selectedData = datas.find(v => v.c_id === nextProps.value);
      if (selectedData) {
        nState = { ...nState, valueSpan: selectedData.c_name };
      }
    }
    nState && this.setState(nState);
  }

  onCancel = () => {
    this.setState({ visible: false });
  }

  onSearch = () => {
    const { search, searchDatas } = this.state;
    if (search === '') this.setState({ datas: searchDatas, current: 1 });
    else this.setState({ datas: searchDatas.filter(v => v.c_name.indexOf(search) >= 0), current: 1})
  }

  setSearchValue = (val) => {
    this.setState({ search: val });
  }

  onPageChange = (current) => {
    this.setState({ current });
  }

  onRow = (record) => {
    return {
      onClick: () => {
        const { onChange } = this.props;
        this.setState({ visible: false, value: record.c_id, valueSpan: record.c_name });
        typeof onChange === 'function' && onChange(record.c_id, record);
      }
    }
  }

  render() {
    const { prefixCls, title, rowKey = 'id', columns, loading } = this.props;
    const { valueSpan, visible, datas, count, search, current } = this.state;
    return (
      <div className={prefixCls}>
        <Input value={valueSpan} onChange={() => null} addonAfter={<Icon type="search" onClick={() => this.setState({ visible: true })} />} />
        <Modal
          title={title}
          className={`${prefixCls}-Modal`}
          visible={visible}
          onCancel={this.onCancel}
          maskClosable={false}
          width={700}
          footer={[
            <Button key="cusCancel" onClick={this.onCancel}>返回</Button>
          ]}
        >
          <div className={`${prefixCls}-Modal-search`}>
            <Search value={search} onChange={(e) => this.setSearchValue(e.target.value)} onSearch={this.onSearch} />
          </div>
          <Table
            rowKey={rowKey}
            columns={columns}
            dataSource={datas}
            loading={loading}
            size="middle"
            pagination={{
              total: count,
              pageSize: 5,
              current,
              onChange: this.onPageChange,
            }}
            onRow={this.onRow}
          />
        </Modal>
      </div>
    )
  }
}

export default App;


// WEBPACK FOOTER //
// ./src/components/public/cs-browser/index.js